export default __webpack_public_path__ + "static/media/icons-project-subject.e1c3cd51.svg";